import styled from 'styled-components'
import { Link } from 'react-router'
import { Button } from '@bm-js/atlascloud-ui'
import { colors, measurments } from '../utils/config'

const StyledErrorRouteContent = styled.div`
  padding-top: ${measurments.navHeight}px;
  text-align: center;
  height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  h1 {
    color: ${colors.gray600};
    font-weight: 400;
  }
`

const ErrorRouteContent = () => {
  return (
    <StyledErrorRouteContent>
      <div>
        <p className='m0 l b'>Rackarns!</p>
        <h1 className='m0 xs'>Sidan kunde inte hittas</h1>
        <Link to='/'>
          <Button className='mtop2'>Tillbaka till startsidan</Button>
        </Link>
      </div>
    </StyledErrorRouteContent>
  )
}

export default ErrorRouteContent
